// Steps for the first-run guided tour (see GuidedTour.js).
//
// Each step: { route, selector?, title, body, placement? }
//  - route    : where to navigate before showing the step (teacher app paths).
//  - selector : a [data-tour="..."] anchor to spotlight. If it isn't found on the
//               page, the step gracefully falls back to a centered card — so the
//               tour can never break a screen even if the UI shifts.
//  - placement: preferred card position relative to the anchor ("bottom" default).
//
// The tour is a walkthrough of the LIVE app on a freshly-seeded sample classroom,
// so every screen it lands on already has realistic data to look at.

const tourSteps = [
  {
    route: "/dashboard",
    selector: '[data-tour="sample-class"]',
    title: "👋 This is your sample class",
    body: "We set one up with students, sign-out history, attendance, a library and more — so you can try every feature right now, no roster needed. Remove it with one click whenever you're ready for your real students.",
    placement: "bottom",
  },
  {
    route: "/classsignoutpage",
    selector: '[data-tour="signout-grid"]',
    title: "Hall-pass sign-out",
    body: "Tap a student to sign them out, tap their card again when they're back. Two sample students are already out — try signing one back in.",
    placement: "top",
  },
  {
    route: "/attendance",
    title: "Attendance in seconds",
    body: "Tap students to mark them present. Your sample class already has today's attendance started — a couple are left absent so you can see how the absent view works.",
  },
  {
    route: "/studentinsights",
    title: "Student insights",
    body: "Pick a student to see how often they leave, where they go, and for how long. The sample history feeds these charts so you can see real patterns.",
  },
  {
    route: "/emergency",
    title: "Emergency accountability",
    body: "Start a drill or a real emergency and account for every student building-wide. This is the heart of ClassBoon's safety layer.",
  },
  {
    route: "/library",
    title: "Library & lending",
    body: "Check books and devices in and out. We pre-loaded a few sample books and a Chromebooks tracker so you can see how loans look.",
  },
  {
    route: "/dashboard",
    title: "🎉 You're all set!",
    body: "Explore as much as you like. When you're ready for your real roster, create a class — and remove the sample data with one click from its card or in Settings.",
  },
];

export default tourSteps;
